import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DetailRowService, ToolbarService, EditService, GridComponent, GridModel, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, UnidadFuncionalService, ComunidadService, TenantService } from '../../../../src/app/shared/services';
import { Comunidad, MenuFuncionCodes, SearchComunidadRequest, LocalStorageKeys, UnidadFuncionalPersona, UnidadFuncionalTipoRelacion, SaveUnidadFuncionalPersona,
  DialogConfirmRequest, DialogConfirmResponse, TenantFeatureFlags, UnidadFuncionalRelacionesRequestDto, SaveUnidadFuncionalPersonaRelacionDto
 } from '../../../../src/app/shared/model';

import { DialogUnidadFuncionalPersonaGestionComponent } from '../../pages/unidad-funcional/components/dialogUnidadFuncionalPersonaGestion.component';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogUnidadFuncionalPersonaImportComponent } from './components/dialog-unidad-funcional-persona-import.component';


@Component({
  selector: 'app-unidadFuncionalPersona',
  templateUrl: './unidadFuncionalPersona.component.html',
  styleUrls: [ './unidadFuncionalPersona.component.scss' ],
  providers: [ DetailRowService, EditService, ToolbarService ]
})

export class UnidadFuncionalPersonaComponent implements OnInit, OnDestroy {

  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('childGridActionTemplate')
  public childGridActionTemplate: any;
  public childGrid: GridModel;

  // public data: DataManager;
  public childData: UnidadFuncionalPersona[] = []
  total: number = 0;
  msgError: string = "";

  searchForm: FormGroup;
  // formGroup: FormGroup;

  tipoRelacionList: UnidadFuncionalTipoRelacion[];
  comunidadList: Comunidad[];
  unidadFuncionalList: SaveUnidadFuncionalPersonaRelacionDto[];
  unidadFuncionalDetectionList:number;

  isSaving: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isTipoRelacionSearching: boolean = false;
  isUfSearching: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  canViewUf: boolean = false;
  showImport: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private sub: Subscription;

  constructor(
    @Inject(ViewContainerRef)
    private viewContainerRef: ViewContainerRef,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private service: UnidadFuncionalService,
    private comunidadService: ComunidadService,
    private tenantService: TenantService,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.UNIDAD_FUNCIONAL_PERSONA).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
    this.initializeRouterSubscription();
  }

  loadView() {
    this.canView = true;

    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewUf = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_LIST || x == MenuFuncionCodes.UNIDAD_FUNCIONAL_EDIT);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.buildSearchForm();
    this.getComunidades();

    setTimeout(() => {
      this.initializeChildGrid();
    }, 100);
  }

  initializeChildGrid() {
    if (this.tenantFeatureFlags?.HabilitarControlExpensas) {
      this.childGrid = {
        queryString: 'UnidadFuncionalId',
        toolbar: [], //['Add', 'Edit', 'Delete', 'Update', 'Cancel'],
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false },
        load() {
          this.registeredTemplate = {};   // set registertemplate value as empty in load event
        },
        columns: [
          { headerText: 'Nombre', field: 'PersonaNombre', textAlign: 'Center', width: 120 },
          { headerText: 'Apellido', field: 'PersonaApellido', textAlign: 'Center', width: 150 },
          { headerText: 'Mail', field: 'PersonaMailContacto', textAlign: 'Center', width: 150 },
          { headerText: 'Tipo Relación', field: 'TipoRelacionNombre', textAlign: 'Center', width: 120 },
          { headerText: 'Expensa?', field: 'EnviarExpensaTexto', textAlign: 'Center', width: 70 },
          // { headerText: 'Fecha Últ. Envio', field: 'FechaEnvioMailInvitacion', textAlign: 'Center', width: 120 },
          { headerText: 'Acciones', textAlign: 'Center', width: 120, template: this.childGridActionTemplate },
        ]
      };
    }
    else {
      this.childGrid = {
        // dataSource: data,
        queryString: 'UnidadFuncionalId',
        toolbar: [], //['Add', 'Edit', 'Delete', 'Update', 'Cancel'],
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false },
        load() {
          this.registeredTemplate = {};   // set registertemplate value as empty in load event
        },
        columns: [
          { headerText: 'Nombre', field: 'PersonaNombre', textAlign: 'Center', width: 120 },
          { headerText: 'Apellido', field: 'PersonaApellido', textAlign: 'Center', width: 150 },
          { headerText: 'Mail', field: 'PersonaMailContacto', textAlign: 'Center', width: 150 },
          { headerText: 'Tipo Relación', field: 'TipoRelacionNombre', textAlign: 'Center', width: 120 },
          // { headerText: 'Fecha Últ. Envio', field: 'FechaEnvioMailInvitacion', textAlign: 'Center', width: 120 },
          { headerText: 'Acciones', textAlign: 'Center', width: 120, template: this.childGridActionTemplate },
        ]
      };
    }

    this.childGridActionTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.childGridActionTemplate.elementRef.nativeElement.propName = 'template';
  }

  hasComunidadSelected() {
    return (this.unidadFuncionalList != null && this.unidadFuncionalList.length > 0);
  }

  onDataBound(): void {
    this.expandAll();
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildSearchForm() {
    this.searchForm = this.formBuilder.group({
      'ComunidadId': [null]
    });
  }

  onGridActionFailure(event: any): void {
    // console.log(event);
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  searchUnidadesFuncionales() {
    var cId = this.searchForm.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una comunidad para continuar con la operación", "Error");
      return false;
    }

    if (cId != null && cId > 0) {
      var r = new UnidadFuncionalRelacionesRequestDto(cId);
      this.isSearching = true;

      this.service.getRelaciones(r).subscribe(data =>{
        if (data != null) {
          this.isSearching = false;
          this.unidadFuncionalList = data.Result;
          this.unidadFuncionalDetectionList = this.unidadFuncionalList.map(x => x.Relaciones.length).reduce((a, b) => a + b, 0);
          this.bindGridData();
          this.expandAll();
        }
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err, true);
      });

      this.showImport = true;
    }
  }

  bindGridData() {
    this.grid.dataSource = this.unidadFuncionalList;
    this.childData = [].concat.apply([], this.unidadFuncionalList?.map(x => x.Relaciones));
    this.grid.childGrid.dataSource = this.childData;
    this.grid.refresh();
  }

  expandAll(): void {
    if (this.grid != null && this.grid.detailRowModule != null)
      this.grid.detailRowModule.expandAll();
  }

  collapseAll(): void {
    if (this.grid != null && this.grid.detailRowModule != null)
      this.grid.detailRowModule.collapseAll();
  }

  executeImportFile() {
    const dialogRef = this.dialog.open(DialogUnidadFuncionalPersonaImportComponent, {
      width: '50%',
      data: { cId : this.searchForm.get("ComunidadId")?.value ,
              ufsList : this.unidadFuncionalList
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.Accepted) {
        this.searchUnidadesFuncionales();
      }
    });
  }

  executeExpoFile() {
    //TODO
    this.sharedFunctions.showMessage("Proximamente!", "En Proceso");
  }

  onUfView(uf: any) {
    if (this.canViewUf) {
      if (uf == null || uf.UnidadFuncionalId == null || uf.UnidadFuncionalId <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar una UF", "Error");
        return false;
      }

      this.router.navigate(['unidad-funcional-edit', uf.UnidadFuncionalId]);
    }
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  onUfPersonAdd(uf: any) {
    const dialogRef = this.dialog.open(DialogUnidadFuncionalPersonaGestionComponent, {
      width: '90%',
      data: new SaveUnidadFuncionalPersona(0, uf.UnidadFuncionalId, uf.UnidadFuncionalNumero, 0, null, null, null, null, null, true, false, false, null,null)
    });

    dialogRef.afterClosed().subscribe((result: SaveUnidadFuncionalPersona) => {
      if (result != null)
        this.onPersonaRelacionSave(result, null);
    });
  }

  onGuardar() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest("Confirmación de Relaciones de UFs", "¿Está seguro que desea guardar los cambios?", "Sí", "No")
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      this.sub.unsubscribe();
      if (result != null && result?.Accepted){
        this.isSaving = true;
        this.service.saveRelaciones(this.unidadFuncionalList).subscribe(data => {
          this.isSaving = false;
          if (data.Success) {
            this.sharedFunctions.showMessage("Se cargaron exitosamente los datos de las personas para las unidades funcionales", "Operación Exitosa!");
            // this.sharedFunctions.reloadCurrentRoute();
          }
          else {
            this.sharedFunctions.showMessage("Ocurrió un error guardando las relaciones.", "Error");
          }
        },
        (err: HttpErrorResponse) => {
          this.isSaving = false;
          this.sharedFunctions.handleError(err, true);
        });
      }
    });
  }

  onCancel() {
    this.location.back();
  }

  onPersonaRelacionView(data: any) {
    if (data != null) {

      const dialogRef = this.dialog.open(DialogUnidadFuncionalPersonaGestionComponent, {
        width: '90%',
        data: new SaveUnidadFuncionalPersona(data.Id, data.UnidadFuncionalId, data.UnidadFuncionalNumero, data.PersonaId, data.PersonaNombre, data.PersonaApellido,
                data.PersonaMailContacto, data.TipoRelacionId, data.TipoRelacionNombre, data.PuedeEnviarInvitacion, false, data.EnviarExpensa, data.EnviarExpensaTexto,null)
      });

      dialogRef.afterClosed().subscribe((result: SaveUnidadFuncionalPersona) => {
        if (result != null)
          this.onPersonaRelacionSave(result, data.index);
      });
    }
  }

  onPersonaRelacionSave(nuevaRelacion: SaveUnidadFuncionalPersona, gridIndex: number | null) {

    var ufIndex = this.unidadFuncionalList.findIndex(f => f.UnidadFuncionalId == nuevaRelacion.UnidadFuncionalId);
    if (ufIndex < 0) {
      this.sharedFunctions.showMessage("No se encontró la UF seleccionada", "Error");
      return false;
    }

    if (this.unidadFuncionalList[ufIndex].Relaciones == null)
      this.unidadFuncionalList[ufIndex].Relaciones = [];



    var relacionIndex = (gridIndex ?? -1);
    if (relacionIndex < 0) {
      if (nuevaRelacion.PersonaMailContacto != null && nuevaRelacion.PersonaMailContacto.length > 0)
        relacionIndex = this.unidadFuncionalList[ufIndex].Relaciones.findIndex(f => f.PersonaMailContacto == nuevaRelacion.PersonaMailContacto);
    }

    if (relacionIndex >= 0){
      nuevaRelacion.Cambio = true;
      this.unidadFuncionalList[ufIndex].Relaciones[relacionIndex] = nuevaRelacion;
    }
    else
      this.unidadFuncionalList[ufIndex].Relaciones.push(nuevaRelacion);

    this.bindGridData();
  }

  onPersonaRelacionDelete(data: any) {
    if (data != null && data.index >= 0) {
      var ufIndex = this.unidadFuncionalList.findIndex(f => f.UnidadFuncionalId == data.UnidadFuncionalId);
      if (ufIndex >= 0 && this.unidadFuncionalList[ufIndex].Relaciones != null) {
        this.unidadFuncionalList[ufIndex].Relaciones.splice(data.index, 1);
        this.bindGridData();
      }
    }
  }

  sendInvite(item: SaveUnidadFuncionalPersona) {
    if (item != null && item.PuedeEnviarInvitacion) {
      if (item.PersonaMailContacto == null || item.PersonaMailContacto.length == 0) {
        this.sharedFunctions.showMessage("La persona no tiene configurado un mail para realizar el envio", "Error");
        return false;
      }

      this.service.sendNewUserInvitation(item).subscribe(data => {
        if (data.Success && data.Result == true) {
          this.sharedFunctions.showMessage("Se envió correctamente un correo de invitación al correo " + item.PersonaMailContacto, "Operación Exitosa!");
        }
        else {
          this.sharedFunctions.showMessage("Ocurrió un error enviando el mail de invitación al usuario.", "Error");
        }
      },
      (err: HttpErrorResponse) => {
        this.sharedFunctions.handleError(err, true);
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private initializeRouterSubscription() {
    this.sub = this.router.events
    .pipe(
      filter(event => event instanceof NavigationStart),
      map(event => event as NavigationStart),
    )
    .subscribe(
      event => {
        const currentRoute = this.router.routerState;
        let Cambios = this.unidadFuncionalList?.map(x=> x.Relaciones).some(x=> x.some(y=> y.Cambio));

        if (this.unidadFuncionalDetectionList != (this.childGrid.dataSource as any)?.length || Cambios) {

          this.router.navigateByUrl(currentRoute.snapshot.url, { skipLocationChange: true });

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest(null, "Quedan cambios pendientes, ¿Desea guardar los cambios?", null, null)
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result?.Accepted){
              this.sub.unsubscribe();
              this.service.saveRelaciones(this.unidadFuncionalList).subscribe(data => {
                this.isSaving = false;
                if (data.Success) {
                  this.sharedFunctions.showMessage("Se cargaron exitosamente los datos de las personas para las unidades funcionales", "Operación Exitosa!");
                  this.unidadFuncionalDetectionList = (this.childGrid.dataSource as any)?.length;
                  this.unidadFuncionalList?.map(x=> x.Relaciones).forEach(x=> x.forEach(y=> y.Cambio = false));
                  this.location.back();
                }
                else {
                  this.sharedFunctions.showMessage("Ocurrió un error guardando las relaciones.", "Error");
                }
              },
              (err: HttpErrorResponse) => {
                this.isSaving = false;
                this.sharedFunctions.handleError(err, true);
              });
            }
            else if (result != null && !result?.Accepted) {
              this.sub.unsubscribe();
              this.location.back();
              this.location.back();
            }
          });
        }
    });
  }
}
